import type { FC, PropsWithChildren } from 'react';
import cls from 'classnames';
import './text.scss';

type Props = {
  size: '1' | '2';
  color: '1' | '2' | '3';
  className?: string;
};

const sizes = {
  '1': 'textSizeNormal',
  '2': 'textSizeSmall'
};

const colors = {
  '1': 'textColor1',
  '2': 'textColor2',
  '3': 'textColor3'
};

const ComponentText: FC<PropsWithChildren<Props>> = ({ size, color, className, children }) => {
  return <p className={cls(className, sizes[size], colors[color])}>{children}</p>;
};

export default ComponentText;
